/**
 * @desc 财务画像-财务造假分析-舞弊路径分析
 * @author caoyx
 */
import style from '../common.scss';
import React from 'react';
import { Table, Row, Col } from 'antd';
import { PAGE_SIZE } from '../../../../constants/common';
import { removeCommonIndex, checkSearch } from '../../common/commons';
import BBDLineBar from '../../../common/echarts/BBDLineBar';

export default function PathAnalysis({ data }) {
    const { fraudPathIndex, fraudPathDescription, list = [], chart = {}, tableTitle } = data;

    const filterTitle = tableTitle.filter(d => d && d.indexOf('行业均值') === -1); // 过滤行业均值之后的头部

    const columns =  [{
        title: '时间',
        dataIndex: 'year',
        width: 70
    }].concat(filterTitle.map(d => ({
        title: d,
        dataIndex: d,
        render: val => removeCommonIndex(val)
    })));

    const fraudPathIndexHtml = fraudPathIndex
        .replace(/偏大/g, '<span style="color:#e03c3c;font-size:16px;">偏大</span>')
        .replace(/正常/g, '<span style="color:#ff9a00;font-size:16px;">正常</span>')
        .replace(/偏小/g, '<span style="color:#05ce05;font-size:16px;">偏小</span>');

    // 财务舞弊路径折线图配置
    let options = option(chart), listData = formatList(list, filterTitle);

    return (
        <div className={ style.analysisBox }>
            <Row>
                <Col span={14}>
                    <div className={style.pathAnalysisArea}>
                        <div
                            className={style.title}
                            dangerouslySetInnerHTML={{
                                __html: fraudPathIndexHtml
                            }}
                        />
                        <div>{fraudPathDescription}</div>
                    </div>
                    <Table
                        bordered
                        rowKey="year"
                        dataSource={listData}
                        columns={columns}
                        pagination={listData.length > PAGE_SIZE}
                    />
                </Col>
                <Col span={10}>
                    <div className={style.lineBar}>
                        <BBDLineBar option={options} />
                    </div>
                </Col>
            </Row>
        </div>
    );
}

// 财务舞弊路径折线图配置
function option(chart) {
    let data = [], years = [];
    for (let d in chart) {
        data.push({ name: d + '占比', data: chart[d] });
    }

    years = data[0].data.map(d => d.key) || [];

    return {
        lineData: data,
        category: years,
        legend: {
            type: 'scroll',
            left: 10
        },
        grid: {
            top: 25
        },
        color: ['#3370C8', '#F99248', '#19BDE0']
    };
}

// 获取目标年的数据
function formatList(data, title) {
    let companyInfo = checkSearch();
    let item = data.find(d => (d.year + '') === companyInfo.reportYear); // 当前年数据
    let averageData = { year: '行业平均水平' };

    title.forEach(t => {
        averageData[t] = item[t + '行业均值'];
    });

    return data.concat(averageData);
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/financialFraudAnalysis/subComponents/PathAnalysis.jsx